// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__JhRZT","title":"BackImages_title__2AfC3","images":"BackImages_images__37qkC"};